import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet";

import NavbarFixed from "../components/NavbarFixed";
import Footer from "../components/Footer";
import "../assets/fonts/fonts.css";
import img from "../assets/images/contact.jpg";
import ScrollDown from "../components/ScrollDown";
import ContactForm from "../components/contact/ContactForm";

export default function Contact() {
  const [contactTextOpacity, setContactTextOpacity] = useState(1);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const fadePoint = window.innerHeight / 2;

      if (scrollPosition >= fadePoint) {
        setContactTextOpacity(0); // Fade out
      } else {
        setContactTextOpacity(1); // Fade in
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div>
      <Helmet>
        <title>moses.zhang.contact</title>
      </Helmet>
      <NavbarFixed visible={true} />
      {/* Section 1: Static Background */}
      <section className="relative h-screen bg-fixed bg-black bg-opacity-100 bg-center bg-cover z-[-2]">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 2 }}
          className="fixed inset-0 flex justify-center items-center z-[-1]"
          style={{
            backgroundImage: `url(${img})`,
            backgroundSize: "cover", // Optional: to cover the entire div
            backgroundPosition: "center", // Optional: to center the image
            backgroundColor: "rgba(0,0,0,0.3)",
            backgroundBlendMode: "darken",
          }}
        >
          <motion.h1
            initial={{ opacity: 1 }}
            animate={{ opacity: contactTextOpacity }} // Bind opacity to the scroll
            className="text-white text-6xl font-bold"
          >
            Contact
          </motion.h1>
        </motion.div>
      </section>

      <ScrollDown delay={0.6} />

      <motion.section
        className="
          relative h-screen flex items-center justify-center
          border-y border-white/15
          bg-neutral-900/40 backdrop-blur-xl backdrop-saturate-150
          supports-[backdrop-filter]:bg-neutral-900/40
        "
        initial={{ opacity: 0, y: 100 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div
          className="pointer-events-none absolute inset-x-0 -top-px h-px bg-gradient-to-r from-transparent via-white/30 to-transparent"
          aria-hidden
        />

        <div
          className="pointer-events-none absolute inset-0 [mask-image:radial-gradient(60%_60%_at_50%_35%,black,transparent)] bg-white/5"
          aria-hidden
        />

        <ContactForm/>
      </motion.section>
      <Footer />
    </div>
  );
}
